<template>
  <div class="plans_wrap">
    <div class="addPlanBtn">
      <el-button type="primary" @click="addPlan">创建计划</el-button>
      <i class="el-icon-warning-outline" @click="showTips = true"></i>
    </div>
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="计划" name="plan">
        <el-table
          :data="plans"
          border
          style="width: 100%"
          v-loading="dataLoading"
        >
          <el-table-column
            v-for="(column, index) in plan_columns"
            :key="column.prop"
            :label="column.label"
            :prop="column.prop"
            :width="column.width || 'auto'"
            :fixed="index < 2 ? 'left' : false"
          >
            <template slot-scope="scope">
              <span v-if="column.prop === 'switch'">
                <el-switch
                  v-model="scope.row.switch"
                  :active-value="1"
                  :inactive-value="0"
                  @change="switchPlanState(scope.row)"
                >
                </el-switch>
              </span>
              <span v-else-if="column.prop === 'ad_status'">
                {{ scope.row['ad_status'] | adStatusText }}
              </span>
              <span v-else-if="column.prop === 'action'">
                <el-button type="text" @click="showDetail(scope.row)"
                  >查看计划</el-button
                >
                <template v-if="scope.row['ad_status'] == 1">
                  <el-button type="text" @click="modifyPlan(scope.row)"
                    >修改计划</el-button
                  >
                  <el-button type="text" @click="cancelPlan(scope.row)"
                    >取消计划</el-button
                  >
                </template>
              </span>
              <span v-else>{{ scope.row[column.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 30, 40]"
          @size-change="handlePlanSizeChange"
          @current-change="handlePlanCurrentChange"
          :current-page="plan_page"
          :page-size="plan_page_size"
          :total="plan_total"
        ></el-pagination>
      </el-tab-pane>
      <!-- <el-tab-pane label="广告组" name="adGroup">
        <adGroupData />
      </el-tab-pane> -->
    </el-tabs>
    <el-dialog
      title="推广计划说明"
      :visible.sync="showTips"
      width="60%"
      :before-close="() => (showTips = false)"
    >
      <div v-html="tips.replaceAll('\n', '<br/>')" />
      <template #footer>
        <span>
          <el-button type="primary" @click="showTips = false"
            >我知道了</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import mixins from '../../../mixins/miniBeanBidding/home.mixin';
// import adGroupData from './components/adGroupData.vue';
export default {
  // components: {
  //   adGroupData,
  // },
  mixins: [mixins],
};
</script>
<style lang="scss" scoped>
.plans_wrap {
  position: relative;
}
.addPlanBtn {
  position: absolute;
  right: 33px;
  font-size: 14px;
  // padding: 10px 16px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  .el-icon-warning-outline {
    font-size: 24px;
    margin-left: 10px;
    cursor: pointer;
    color: #fd9b21;
  }
}
.tabs {
  margin-top: 8px;
}
</style>
